import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EN from './locales/en.json';
import FR from './locales/fr.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: EN },
      fr: { translation: FR },
    },
    lng: localStorage.getItem('i18nextLng') || (navigator.language && navigator.language.startsWith('fr') ? 'fr' : 'en') || 'fr',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
  });

// keep selected language in localStorage
i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem('i18nextLng', lng); } catch (e) { /* ignore */ }
});

export default i18n;
